const labels = Object.freeze({
  HOME: 'Home',
  MY_ACTIONS: 'My Actions',
  MANAGE_DIGITAL_ASSETS: 'Manage Digital Assets',
  CONTACTS: 'Contacts',
  MY_ACCOUNT: 'My Account',
  HELP: 'Help',
  LOGIN: 'Login',
  LOGIN_TO_FX: 'Login to FileXpress',
  LOG_OUT: 'Log Out',
  CANCEL: 'Cancel',
  AMEX_REP_HELP_MESSAGE: 'Please try again or contact AMEX Representative for additional help and support.',
});

export default labels;
